interface SettingsStatusBadgeProps {
  status: string;
  className?: string;
}

const statusColors: Record<string, string> = {
  "ativo": "bg-primary-100 text-primary-800 border-primary-200",
  "inativo": "bg-foreground-100 text-foreground-600 border-foreground-200",
  "em revisão": "bg-warning-100 text-warning-800 border-warning-200",
  "pendente": "bg-warning-100 text-warning-800 border-warning-200",
  "bloqueado": "bg-danger-100 text-danger-800 border-danger-200",
  "em análise": "bg-warning-100 text-warning-800 border-warning-200",
  "em configuração": "bg-caution-100 text-caution-800 border-caution-200",
  "configurado": "bg-accent-100 text-accent-800 border-accent-200",
  "não configurado": "bg-foreground-100 text-foreground-500 border-foreground-200",
  "planejado": "bg-secondary-100 text-secondary-800 border-secondary-200",
  "erro": "bg-danger-100 text-danger-800 border-danger-200",
  "sucesso": "bg-primary-100 text-primary-800 border-primary-200",
  "falha": "bg-danger-100 text-danger-800 border-danger-200",
};

export default function SettingsStatusBadge({ status, className = "" }: SettingsStatusBadgeProps) {
  const colorClass = statusColors[status] || "bg-foreground-100 text-foreground-600 border-foreground-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border ${colorClass} ${className}`}>
      {status}
    </span>
  );
}